import React from "react";

// Shared palette for the MalayalamCinema edition
export const C = {
  bg: "#FBF6EC", card: "#FFFDF8", navy: "#183A5A", ink: "#1b2b38",
  gold: "#B8892F", goldL: "#C99A3F", rust: "#C65A2E", teal: "#2E7D78",
  olive: "#7C7A34", line: "#EADFC8", muted: "#7d7259",
};

export const IMG = {
  hero: "https://static.prod-images.emergentagent.com/jobs/c6af1a77-2b65-44c2-9c4e-049400224684/images/686b305cf2aaeefebb35e411215a06edaa666ab48c2516599605200c9365bccc.jpeg",
  nowShowing: "https://images.unsplash.com/photo-1598899134739-24c46f58b8c0?crop=entropy&cs=srgb&fm=jpg&q=85&w=640",
  news: "https://images.unsplash.com/photo-1578941838877-141265f3a898?crop=entropy&cs=srgb&fm=jpg&q=85&w=640",
  star: "https://images.unsplash.com/photo-1666858443985-fead1d59b4f7?crop=entropy&cs=srgb&fm=jpg&q=85&w=640",
  archive: "https://images.unsplash.com/photo-1633510964011-05b18d618db5?crop=entropy&cs=srgb&fm=jpg&q=85&w=640",
  kerala1: "https://images.unsplash.com/photo-1596337323475-d2bf40338c8a?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  kerala2: "https://images.unsplash.com/photo-1675267149427-5d2caacc01fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  kerala3: "https://images.unsplash.com/photo-1694011772133-dc4b3ff3f24f?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  intv1: "https://images.unsplash.com/photo-1554941829-202a0b2403b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  intv2: "https://images.unsplash.com/photo-1637124396916-4f85d4bf9fdd?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  hist1: "https://images.unsplash.com/photo-1568876694728-451bbf694b83?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  hist2: "https://images.unsplash.com/photo-1589569334232-fdc917c38226?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  mem1: "https://images.unsplash.com/photo-1730791480874-b1c31992169e?crop=entropy&cs=srgb&fm=jpg&q=85&w=500",
  mem2: "https://images.unsplash.com/photo-1568876694728-451bbf694b83?crop=entropy&cs=srgb&fm=jpg&q=85&w=500&sat=-100",
};

// Navigation (tabs remain in English by design)
export const NAV = [
  { label: "Home", to: "/malayalam" },
  { label: "About AMMA", to: "/malayalam/about-amma" },
  { label: "Meet the Star", to: "/malayalam/meet-the-star" },
  { label: "Star Address", to: "/malayalam/star-address" },
  { label: "Movies", to: "/malayalam/movies", caret: true },
  { label: "Cinema History", to: "/malayalam/cinema-history" },
  { label: "Memories", to: "/malayalam/memories" },
  { label: "Interview", to: "/malayalam/interviews" },
  { label: "Gallery", to: "/malayalam/gallery" },
];

export const Logo = () => (
  <svg viewBox="0 0 120 96" width="112" height="90" aria-hidden="true">
    <rect x="4" y="10" width="112" height="76" rx="8" fill="none" stroke={C.gold} strokeWidth="4" />
    {[16, 30, 44, 58, 72].map((y) => (<rect key={`l${y}`} x="12" y={y} width="8" height="8" rx="1.5" fill={C.gold} />))}
    {[16, 30, 44, 58, 72].map((y) => (<rect key={`r${y}`} x="100" y={y} width="8" height="8" rx="1.5" fill={C.gold} />))}
    <circle cx="78" cy="30" r="7" fill={C.goldL} />
    <path d="M40 74 C41 60 43 52 45 44" stroke={C.gold} strokeWidth="3" fill="none" strokeLinecap="round" />
    <path d="M45 44 C38 40 32 41 28 46 M45 44 C52 40 58 41 62 47 M45 44 C40 36 41 30 45 26 M45 44 C50 38 56 37 60 39" stroke={C.gold} strokeWidth="2.5" fill="none" strokeLinecap="round" />
    <path d="M30 74 q30 12 56 0 q-28 8 -56 0 Z" fill={C.goldL} />
    <path d="M52 74 l6 -12" stroke={C.gold} strokeWidth="2" strokeLinecap="round" />
  </svg>
);
